import DatasetTreeNode from '../dataset-tree/logical/DatasetTreeNode';
import CategoryIntlProvider from '../intl/CategoryIntlProvider';

/**
 * Pre-fetches dataset titles for a given dataset tree to be queried later.
 */
class DatasetTitlesTranslator {
  private translations: Map<DatasetTreeNode, string> = new Map();

  constructor(private intlProvider: CategoryIntlProvider) {}

  /**
   * Recursively fetches and caches localized titles for a given dataset subtree
   * and returns a promise that resolves when the process is finished.
   *
   * @param node - Dataset subtree root.
   */
  public async fetchTitlesFor(node: DatasetTreeNode): Promise<void> {
    const title = await this.intlProvider.getDatasetTitle(node);

    this.translations.set(node, title);

    for (const child of node.getChildren()) {
      await this.fetchTitlesFor(child);
    }
  }

  /**
   * Returns a previously loaded dataset title from cache.
   *
   * @throws Error if {@link DatasetTitlesTranslator.fetchTitlesFor} has never
   * been called for `node` or its ancestors.
   *
   * @param node - Dataset object to get a title for.
   */
  public getDatasetTitle(node: DatasetTreeNode): string {
    const title = this.translations.get(node);

    if (title === undefined) {
      throw new Error('Unknown dataset node');
    }

    return title;
  }
}

export default DatasetTitlesTranslator;
